import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import Placeholder from "%/dynamic-component-editor/options/placeholder";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";

export default class InputOptions extends BaseOptionsBundle {

  optionTitle = "Input Options";
  static optionClassName = "i-dynamic-input";

  constructor(values = {}) {
    super(values, [
      Placeholder,
      new LayoutWidth({
        default: "fill",
        hover: "fill",
      }),
    ]);
  }
}
